export default __webpack_public_path__ + "static/media/textandmulti.31891a7d.png";